module.exports = __webpack_public_path__ + "img/switch-gender-both.2755434e.svg";